import AppBar from '@material-ui/core/AppBar';
import React from 'react';
import styled from 'styled-components';

const Header = ({ title, page, Toolbar, Navigation, Drawer, Search, toggleMenu, open }) => {
    const StyledAppBar = styled(AppBar)`
        &.stolo-static {
          position: relative;
          transition:  margin 225ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,width 225ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
          box-shadow: none;
          background-color: ${props => props.theme.palette.secondary.main};
          color: white;
        }
        
        &.stolo-fixed {
          position: fixed;
          transition:  margin 225ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,width 225ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
          box-shadow: none;
          background-color: ${props => props.theme.palette.secondary.main};
          color: white;
        }
        
        & .schnoffle-inner-appbar {
          width: 100%;
          max-width: 50em;
          position: relative;
          margin: 0 auto;
        }
        
        & .stolo-logo {
          height: ${props => props.theme.space[13]};
        }
        
        & .schnoffle-tab-indicator {
           background-color: #E193AB;
           height: 4px;
        }
        
        & .schnoffle-tabs {
           margin: 0 auto;
           text-align: center;
           max-width: 98%;
        }
        
        & .schnoffle-tabs-flex {
           justify-content: center;
        }
    `;

    const NaviClasses = {
        indicator: 'schnoffle-tab-indicator',
        root: 'schnoffle-tabs',
    };

    return (
        <React.Fragment>
            <StyledAppBar
                classes={{
                    positionStatic: 'stolo-static',
                    positionFixed: 'stolo-fixed',
                }}
                position='static' color='inherit' id='top'
            >
                <div className='schnoffle-inner-appbar'>
                    <Toolbar
                        title={title} page={page} toggleMenu={toggleMenu}
                        open={open} withDrawer={!!Drawer} Search={Search}
                    />
                </div>
                    {Navigation ? <Navigation classes={NaviClasses} /> : null}
            </StyledAppBar>
            {Drawer || null}
        </React.Fragment>
    );
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/header/HeaderBase.js